import { render, staticRenderFns } from "./renzheng.vue?vue&type=template&id=42af5a42&scoped=true&"
import script from "./renzheng.vue?vue&type=script&lang=js&"
export * from "./renzheng.vue?vue&type=script&lang=js&"
import style0 from "./renzheng.vue?vue&type=style&index=0&id=42af5a42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42af5a42",
  null
  
)

export default component.exports